module.exports = __webpack_public_path__ + "static/media/Patrat_gaussian2.839370f7.png";